import React from 'react';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { toggleSaveEditPopup, resetNotification, toggleNotification } from '../../redux/reducers/view';
import {
  resetPathToSaveVersion,
  resetSaveEditForm,
  resetOverwriteVersion,
} from '../../redux/reducers/savedVersions';
import { selectUserVersion, getUserProgramsFullRequest,
} from '../../redux/reducers/userProgramsFull';
import { resetMessage } from '../../redux/reducers/message';

import Popup from '../Popup';

import { COLORS, commonStyles } from '../../styles/styles';

import { toast, ToastContainer, MDBContainer, MDBBtn, MDBNotification } from 'mdbreact';


const Notification = ({view, handleCloseNotification }) =>  {
  let icon;
  let title;
  let color;

  switch (view.notificationType) {
    case 'success':
      icon = 'check-circle';
      title = 'Success'
      color = 'success-color'
      break;
    default:
      icon = 'exclamation-triangle'
      title = 'Error',
      color = 'secondary-color'
      break;
  }
  

  return (
    <MDBContainer onClick={() => handleCloseNotification()}>
      {view.notification && <MDBNotification
   // by default = ∞ ms
    bodyClassName="p-5 font-weight-bold very-dark-grey-text"
    closeClassName="white-text"
    fade
    icon={icon}
    iconClassName="white-text"
    message={view.notificationMessage}
    show = {view.notification}
    text=""
    title={title}
    titleClassName={color+" white-text"}
    style={{
      position: "fixed",
      top: "10px",
      right: "10px",
      zIndex: 9999
    }}
      />}
    </MDBContainer>
  );
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  formState: state.form,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  message: state.messageReducer,
  view: state.viewReducer
});

const mapDispatchToProps = dispatch => ({
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
  resetSaveEditForm: () => dispatch(resetSaveEditForm()),
  resetNotification: () => dispatch(resetNotification()),
  resetOverwriteVersion: () => dispatch(resetOverwriteVersion()),
  resetMessage: () => dispatch(resetMessage()),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('timer', 'handleTimer', null),
  withState('seconds', 'updateSeconds', 0),
  withHandlers({
    handleCloseNotification: props => () => {
      console.log('CLOSE NOTIFY')
      props.handleTimer(null);
     // props.resetPathToSaveVersion();
      props.resetSaveEditForm();
      props.resetNotification();
     // props.selectUserVersion(null);
    
      props.resetOverwriteVersion();
      props.getUserProgramsFullRequest()
      props.resetMessage();
      props.toggleNotification({value:false});
    },
  }),
  lifecycle({
    componentDidMount() {
      const { seconds, updateSeconds, handleTimer, timer, timeOut, handleCloseNotification } = this.props;
      
    },
    componentWillReceiveProps(nextProps) {
      const { toggleSaveEditPopup, savedVersions, seconds } = nextProps;
      console.log('TIMERX', this.props.view.notification)
      if(this.props.view.notification==false && nextProps.view.notification==true){
        this.timer = setTimeout(()=> {
         
          this.props.handleTimer(null);
          
          this.props.resetSaveEditForm();
          this.props.resetNotification();
         // this.props.selectUserVersion(null);
         //this.props.resetPathToSaveVersion();
          this.props.resetOverwriteVersion();
          this.props.getUserProgramsFullRequest()
          this.props.resetMessage();
          this.props.toggleNotification({value:false});
      }, 5000)
      }
      
    },
    componentWillUnmount() {
      console.log('TIMERX', this.timer)
      clearInterval(this.timer);
    },
  }),
  withStyles(styles),
)(Notification);



// WEBPACK FOOTER //
// ./src/Components/Popups/Notification.jsx